import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["showMore", "showLess"]
  static values = {
    initialState: { type: String, default: "less" }
  }

  connect() {
    this.toggle(this.initialStateValue === "more")
  }

  more(ev) {
    if (ev) ev.preventDefault()
    this.toggle(true)
  }

  less(ev) {
    if (ev) ev.preventDefault()
    this.toggle(false)
  }

  toggle(more = true) {
    this.showMoreTargets.forEach(el => el.style.display = more ? "block" : "none")
    this.showLessTargets.forEach(el => el.style.display = more ? "none" : "block")
  }
}
